import { Recurso, UseCaseRecursoAsync } from "lib.common/dist/CleanArch";
import { ProductoDsTienda } from "../entities/ProductoDsTienda";
import { PaginationOptions } from "lib.common/dist/types";
import { ProductoDsTiendaRepository } from "../repositories/ProductoDsTiendaRepository";
import { ErrDevGenerico } from "lib.common/dist/errorHandler";

export class GetAllProductosDsTiendaUseCase<
    T_OUT extends ProductoDsTienda
> extends UseCaseRecursoAsync<PaginationOptions, T_OUT[]> {
    private repository: ProductoDsTiendaRepository<T_OUT>;
    constructor(repository: ProductoDsTiendaRepository<T_OUT>) {
        super();
        this.repository = repository;
    }

    async call(
        pagination?: PaginationOptions,
        selectList?: string[],
        onlyDen?: boolean
    ): Promise<Recurso<T_OUT[]>> {
        try {
            return await this.repository.getAllProductosDsTienda(pagination, selectList, onlyDen);
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT[]>(errorCapa);
        }
    }

}